module.exports = __webpack_public_path__ + "static/img/kv_deco_03.011a675.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/teaser/kv_deco_03.png
// module id = Rsu/
// module chunks = 0